// src/utils/adminRefreshToken.ts - UPDATED
export const adminRefreshToken = async (): Promise<string | null> => {
  try {
    console.log('🔄 Attempting to refresh admin token...');
    
    // Get stored credentials
    const email = localStorage.getItem('admin_email') || 
                  localStorage.getItem('user_email');
    const password = localStorage.getItem('admin_password');
    
    console.log('🔍 Refresh credentials check:', {
      email: email ? 'Present' : 'Missing',
      password: password ? 'Present' : 'Missing'
    });
    
    // If credentials are missing, cannot refresh token
    if (!email || !password) {
      console.warn('❌ Cannot refresh token: Missing email or password');
      return null;
    }
    
    const response = await fetch(`${process.env.REACT_APP_SERVER_ENDPOINT}/admin/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authkey': '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3',
      },
      body: JSON.stringify({
        email: email.trim(),
        password: password,
      }),
    });
    
    console.log('🔍 Token refresh response status:', response.status);
    
    const data = await response.json();
    console.log('🔍 Token refresh response data:', data);
    
    // If response is OK and contains a token, store and return it
    if (response.ok && data.token) {
      localStorage.setItem('admin_token', data.token);
      
      // Also update role if available in response
      if (data.role) {
        localStorage.setItem('user_role', data.role);
        localStorage.setItem('admin_type', data.role);
      }
      
      console.log('✅ Admin token refreshed successfully');
      return data.token;
    }
    
    console.warn('❌ Token refresh failed:', data.message);
    return null;
  } catch (err) {
    console.error('❌ Admin token refresh failed:', err);
    return null;
  }
};